import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getImputas,
  deleteImputa,
  getImputaById,
} from "../helpers/rutaImputas";
import ModalImputa from "./ModalImputa";
import "../css/tableclientes.css";

const TableImputas = () => {
  const [imputas, setImputas] = useState({
    data: {},
    loading: true,
  });

  const [imputa, setImputa] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaImputas();
  }, []);

  const consultaImputas = () => {
    getImputas().then((datos) => {
      console.log("📦 Imputa:", datos);
      setImputas({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaImputas();
  };

  const handleShow = () => setShow(true);

  const modificaImputa = (id) => {
    getImputaById(id).then((resp) => {
      if (resp.ok) {
        setImputa(resp.imputa); // ✅ ahora sí solo el objeto imputa
        handleShow();
      } else {
        console.error("❌ Error al obtener imputa:", resp.error);
      }
    });
  };

  const eliminarImputa = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la imputación?");
    if (confirmar) {
      deleteImputa(id).then(() => {
        consultaImputas();
      });
    }
  };

  return (
    <div className="table-container">
      {!imputas.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Imputación</th>
                </tr>
              </thead>
              <tbody>
                {imputas.data.imputas.map((imputa) =>
                  imputa.activo ? (
                    <tr key={imputa._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaImputa(imputa._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarImputa(imputa._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{imputa.codimp}</td>
                      <td>{imputa.imputa}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalImputa
            show={show}
            handleClose={handleClose}
            imputa={imputa}
          />
        </>
      )}
    </div>
  );
};

export default TableImputas;
